import { Box, Skeleton, Tooltip, Typography, useTheme } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../global/theme/tokens';
import MoneyLabel from '../label/MoneyLabel';

// Compact stat for the collapsed overview bar: small label on top, value below,
// optional trend arrow. Reads clearly at a glance, unlike inline running text.
const MiniStat = ({ label, value, type = 'money', trend, isLoading }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const renderTrend = () => {
    if (!trend || trend.pct === null || trend.pct === undefined || trend.pct === 0) {
      return null;
    }
    const positive = trend.pct > 0;
    const color = positive ? colors.money?.positive : colors.money?.negative;
    const Icon = positive ? ArrowUpwardIcon : ArrowDownwardIcon;
    return (
      <Tooltip title={t('vs prev. period')} placement="top">
        <Box
          component="span"
          className="inline-flex items-center"
          sx={{ color, fontSize: '0.68rem', fontWeight: 500, ml: 0.5 }}
        >
          <Icon sx={{ fontSize: '0.8rem' }} />
          {`${positive ? '+' : ''}${(trend.pct * 100).toFixed(0)}%`}
        </Box>
      </Tooltip>
    );
  };

  return (
    <Box className="flex flex-col" sx={{ minWidth: 0 }}>
      <Typography
        variant="caption"
        sx={{
          color: colors.text,
          opacity: 0.55,
          fontSize: '0.66rem',
          textTransform: 'uppercase',
          letterSpacing: 0.4,
          lineHeight: 1.2,
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </Typography>
      <Box className="flex items-baseline" sx={{ lineHeight: 1.1 }}>
        {isLoading ? (
          <Skeleton width={64} height={20} />
        ) : type === 'money' ? (
          <Typography component="span" sx={{ fontWeight: 700, fontSize: '0.95rem' }}>
            <MoneyLabel money={value ?? 0} variant="inherit" />
          </Typography>
        ) : (
          <Typography
            component="span"
            sx={{ fontWeight: 700, fontSize: '0.95rem', color: colors.text }}
          >
            {value ?? 0}
          </Typography>
        )}
        {!isLoading && renderTrend()}
      </Box>
    </Box>
  );
};

export default MiniStat;
